import { Route } from '@angular/router';
import { AppComponent } from './app.component';
import { MainComponent } from './layout/main/main.component';
import { LibNotFoundComponent, LibThankyouComponent } from '@web-nx-ng-tsc/web-tirewarranty-shared-ui';

export const appRoutes: Route[] = [
  {
    path: '',
    component: MainComponent,
    pathMatch: 'full',
    title: 'GRIP Tire Warranty',
  },
  {
    path: 'thankyou',
    component: LibThankyouComponent,
    pathMatch: 'full',
    title: 'Thank you',
  },
  {
    path: '**',
    component: LibNotFoundComponent,
  },
];
